import { useQuery } from 'react-query'
import {
  FoldersListItem,
  FolderTree,
} from '@dc-shared-web/hooks/api/folder/types'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { Folder } from '@dc-shared-web/hooks/api/folder'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import { fetchFoldersList } from '@dc-shared-web/hooks/api/folder/fetchFoldersList'
import { fetchFolderTree } from '@dc-shared-web/hooks/api/folder/fetchFolderTree'
import { fetchFoldersForMove } from '@dc-shared-web/hooks/api/folder/fetchFoldersForMove'
import { FOLDERS_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'

const QUERY_KEY = ['FolderForMove']
const QUERY_KEY_TREE = ['FolderForMoveTree']

export const useGetFoldersForMove = (currentTeamId: number) => {
  const apiClient = useAxiosContext()

  return useQuery<Folder[], Error>(QUERY_KEY, () =>
    fetchFoldersForMove(apiClient, { currentTeamId })
  )
}

export const useGetFolderTree = (currentTeamUuid: string) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<FolderTree[], Error>(QUERY_KEY_TREE, () =>
    fetchFolderTree(apiClient, { currentTeamUuid })
  )
}

export const useGetFolders = (params: {
  currentTeamUuid: string
  folderUuid?: string
  projectUuid?: string
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<FoldersListItem[], Error>([FOLDERS_QUERY_KEY, params], () =>
    fetchFoldersList(apiClient, params)
  )
}

export interface FolderProject {
  projectId: string
  projectName: string
}

export const splitAndSortFolderProjects = (
  folderProjects: string
): FolderProject[] => {
  const PROJECTS_DELIMITER = '|-@-|'
  const PROJECT_ID_NAME_DELIMITER = '|$@$|'

  const projects = folderProjects?.split(PROJECTS_DELIMITER) || []
  return projects
    ?.map((project) => {
      const projectData = project?.split(PROJECT_ID_NAME_DELIMITER)
      return {
        projectId: projectData?.[0],
        projectName: projectData?.[1],
      } as FolderProject
    })
    .sort((a: FolderProject, b: FolderProject) => {
      // Compare the project names and return -1, 0, or 1
      const nameA = a.projectName.toLowerCase()
      const nameB = b.projectName.toLowerCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
}
